module.exports = __webpack_public_path__ + "static/media/001.2fc604ae.jpg";